<template>
  <div id="results" class="fixed-content">
    <tabs :transition="0" v-model="tab">
      <tab title="Année 2025">
        <page-section title="Année 2025">
          <div class="row">
            <div class="col-xs-12 col-md-6 col-md-offset-3">
              <div class="panel panel-indicator-ok">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Rapport annuel d'activité</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <a class="btn btn-indicator-ok btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2025/SPIADI2025 - Rapport annuel d'activité.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-md-6">
              <div class="panel panel-reaInfADI">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Surveillance des infections</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-reaInfADI btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2025/SPIADI2025 - Rapport national surveillance - octobre 2026.pdf`)">
                    Rapport (validé par Santé Publique France)
                  </a>
                  <hr>
                  <h4>Résultats nationaux</h4>
                  <p>
                    Les résultats nationaux ont été présentés lors de la journée
                    nationale SPIADI, le 2 octobre 2025.
                  </p>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/Mission Day/2025/van-der-mee-valentin.pdf`)"
                     download="SPIADI2025 - Premiers résultats de la surveillance nationale.pdf">
                    Diaporama de présentation des résultats
                  </a>
                  <hr>

                  <h4>Résultats locaux</h4>
                  <p class="text-justify">
                    Les responsables du programme peuvent accéder aux
                    résultats de leur.s établissement.s via leur espace
                    SPIADI.
                  </p>
                  <btn type="default"
                       block
                       @click="$router.push('/establishments/list')">
                    Accéder à l'espace SPIADI
                  </btn>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                    disabled>
                    Protocoles
                  </a>

                </div>
              </div>
              <div class="panel panel-reaExplaur">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>RÉA expl AUR</h3>
                    <p>Étude des souches de <i>Staplylococcus aureus</i>
                      associé aux bactériémies liées à un cathéter
                      dans les services de Réanimation et unités de soins continus</p>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-reaExplaur btn-block"
                     role="button"
                     target="_blank"
                     download="SPIADI2024-2025 - Rapport National RÉA explAUR - juillet 2026"
                     :href="require(`@/assets/documents/2025/SPIADI2024-2025 - Rapport National RÉA explAUR - juillet 2026.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     :href="require(`@/assets/documents/2025/REAEXPLAUR.zip`)"
                     target="_blank"
                     download="SPIADI2025 - RÉA expl AUR.zip">
                    Protocoles
                  </a>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <div class="panel panel-observa4">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Observation des pratiques</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-observa4 btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2025/SPIADI2025 - Rapport national OBSERVA4 - octobre 2026.pdf`)">
                    Rapport (validé par Santé Publique France)
                  </a>
                  <hr>
                  <h4>Résultats nationaux</h4>
                  <p>
                    Les résultats nationaux ont été présentés lors de la journée
                    nationale SPIADI, le 2 octobre 2025.
                  </p>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/Mission Day/2025/van-der-mee-valentin.pdf`)"
                     download="SPIADI2025 - Premiers résultats OBSERVA4.pdf">
                    Diaporama de présentation des résultats
                  </a>
                  <hr>
                  <h4>Résultats locaux</h4>
                  <p class="text-justify">
                    Les responsables du programme peuvent accéder aux
                    résultats de leur.s établissement.s via leur espace
                    SPIADI.
                  </p>
                  <btn type="default"
                       block
                       @click="$router.push('/establishments/list')">
                    Accéder à l'espace SPIADI
                  </btn>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     disabled>
                    Protocoles
                  </a>
                </div>
              </div>
            </div>
          </div>
        </page-section>
      </tab>
      <tab title="Année 2024">
        <page-section title="Année 2024">
          <div class="row">
            <div class="col-xs-12 col-md-6 col-md-offset-3">
              <div class="panel panel-indicator-ok">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Rapport annuel d'activité</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <a class="btn btn-indicator-ok btn-block"
                     role="button"
                     target="_blank"
                     download="SPIADI2024 - Rapport annuel d'activité.pdf"
                     :href="require(`@/assets/documents/2024/SPIADI2024 - Rapport annuel d'activité.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-md-6">
              <div class="panel panel-reaInfADI">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Surveillance des infections</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-reaInfADI btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2024/SPIADI2024 - Rapport national surveillance - janvier 2026.pdf`)"
                     download="SPIADI2024 - Rapport national surveillance - janvier 2026.pdf">
                    Rapport (validé par Santé Publique France)
                  </a>
                  <hr>
                  <h4>Résultats nationaux</h4>
                  <p>
                    Les résultats nationaux ont été présentés lors de la journée
                    nationale SPIADI, le 8 octobre 2024.
                  </p>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/Mission Day/2024/van-der-mee-valentin.pdf`)"
                     download="SPIADI2024 - Premiers résultats de la surveillance nationale.pdf">
                    Diaporama de présentation des résultats
                  </a>
                  <hr>

                  <h4>Résultats locaux</h4>
                  <p class="text-justify">
                    Les responsables du programme peuvent accéder aux
                    résultats de leur.s établissement.s via leur espace
                    SPIADI.
                  </p>
                  <btn type="default"
                       block
                       @click="$router.push('/establishments/list')">
                    Accéder à l'espace SPIADI
                  </btn>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2024/SPIADI2024.zip`)"
                     download="SPIADI2024 - SURVEILLANCE.zip">
                    Protocoles
                  </a>

                </div>
              </div>
              <div class="panel panel-reaExplaur">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>RÉA expl AUR</h3>
                    <p>Étude des souches de <i>Staplylococcus aureus</i>
                      associé aux bactériémies liées à un cathéter
                      dans les services de Réanimation et unités de soins continus</p>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-reaExplaur btn-block"
                     role="button"
                     target="_blank"
                     download="SPIADI2024-2025 - Rapport National RÉA explAUR - juillet 2026"
                     :href="require(`@/assets/documents/2025/SPIADI2024-2025 - Rapport National RÉA explAUR - juillet 2026.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     :href="require(`@/assets/documents/2024/REAEXPLAUR.zip`)"
                     target="_blank"
                     download="SPIADI2024 - RÉA expl AUR.zip">
                    Protocoles
                  </a>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <div class="panel panel-observa4">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Observation des pratiques</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-observa4 btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2024/SPIADI2024 - Rapport national OBSERVA4 - janvier 2026.pdf`)"
                     download="SPIADI2024 - Rapport national OBSERVA4 - janvier 2026.pdf">
                    Rapport (validé par Santé Publique France)
                  </a>
                  <hr>
                  <h4>Résultats nationaux</h4>
                  <p>
                    Les résultats nationaux ont été présentés lors de la journée
                    nationale SPIADI, le 8 octobre 2024.
                  </p>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/Mission Day/2024/van-der-mee-valentin.pdf`)"
                     download="SPIADI2024 - Premiers résultats OBSERVA4.pdf">
                    Diaporama de présentation des résultats
                  </a>
                  <hr>
                  <h4>Résultats locaux</h4>
                  <p class="text-justify">
                    Les responsables du programme peuvent accéder aux
                    résultats de leur.s établissement.s via leur espace
                    SPIADI.
                  </p>
                  <btn type="default"
                       block
                       @click="$router.push('/establishments/list')">
                    Accéder à l'espace SPIADI
                  </btn>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     :href="require(`@/assets/documents/2024/OBSERVA4.zip`)"
                     target="_blank"
                     download="SPIADI2024 - OBSERVA4.zip">
                    Protocoles
                  </a>
                </div>
              </div>

              <div class="panel panel-chronoBioLine">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>ChronoBioLINE</h3>
                    <p>
                      Étude de la contamination microbienne de la ligne de perfusion principale selon la durée
                      d’utilisation en néonatologie.
                    </p>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-chronoBioLine btn-block"
                     role="button"
                     target="_blank"
                     disabled
                     download="SPIADI2024 - Rapport National ChronoBioLINE - juin 2025">
                    Rapport en cours de rédaction
                  </a>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     :href="require(`@/assets/documents/2024/CHRONOBIOLINE.zip`)"
                     target="_blank"
                     download="SPIADI2024 - ChronoBioLINE.zip">
                    Protocoles
                  </a>
                </div>
              </div>
            </div>
          </div>
        </page-section>
      </tab>
      <tab title="Année 2023">
        <page-section title="Année 2023">
          <div class="row">
            <div class="col-xs-12 col-md-6 col-md-offset-3">
              <div class="panel panel-indicator-ok">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Rapport annuel d'activité</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <a class="btn btn-indicator-ok btn-block"
                     role="button"
                     target="_blank"
                     download="SPIADI2023 - Rapport annuel d'activité.pdf"
                     :href="require(`@/assets/documents/2023/SPIADI2023 - Rapport annuel d'activité.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-md-6">
              <div class="panel panel-reaInfADI">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Surveillance des infections</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-reaInfADI btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2023/SPIADI2023 - Rapport National provisoire - juin 2024.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                  <hr>
                  <h4>Résultats nationaux</h4>
                  <p>
                    Les résultats nationaux ont été présentés lors de la journée
                    nationale SPIADI, le 12 octobre 2023.
                  </p>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/Mission Day/2023/surveillance.pdf`)"
                     download="SPIADI2023 - Premiers résultats de la surveillance nationale.pdf">
                    Diaporama de présentation des résultats
                  </a>
                  <hr>

                  <h4>Résultats locaux</h4>
                  <p>
                    Les responsables du programme peuvent accéder aux
                    résultats de leur.s établissement.s via leur espace
                    SPIADI.
                  </p>
                  <btn type="default"
                       block
                       @click="$router.push('/establishments/list')">
                    Accéder à l'espace SPIADI
                  </btn>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2023/SPIADI2023.zip`)"
                     download="SPIADI2023 - SURVEILLANCE.zip">
                    Protocoles
                  </a>
                </div>
              </div>
              <div class="panel panel-reaExplaur">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>RÉA expl AUR</h3>
                    <p>Étude des souches de <i>Staplylococcus aureus</i>
                      associé aux bactériémies liées à un cathéter
                      dans les services de Réanimation et unités de soins continus</p>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-reaExplaur btn-block"
                     role="button"
                     target="_blank"
                     download="SPIADI2023 - Rapport National RÉA explAUR - juin 2024"
                     :href="require(`@/assets/documents/2023/SPIADI2023 - Rapport National RÉA explAUR - juin 2024.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     :href="require(`@/assets/documents/2023/REAEXPLAUR.zip`)"
                     target="_blank"
                     download="SPIADI2023 - RÉA expl AUR.zip">
                    Protocoles
                  </a>
                </div>
              </div>
            </div>

            <div class="col-xs-12 col-md-6">
              <div class="panel panel-observa4">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Observation des pratiques</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-observa4 btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2023/SPIADI2023 - Rapport national OBSERVA4 - juillet 2024.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                  <hr>
                  <h4>Résultats nationaux</h4>
                  <p>
                    Les résultats nationaux ont été présentés lors de la journée
                    nationale SPIADI, le 12 octobre 2023.
                  </p>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/Mission Day/2023/observation.pdf`)"
                     download="SPIADI2023 - Premiers résultats OBSERVA4.pdf">
                    Diaporama de présentation des résultats
                  </a>
                  <hr>
                  <h4>Résultats locaux</h4>
                  <p class="text-justify">
                    Les responsables du programme peuvent accéder aux
                    résultats de leur.s établissement.s via leur espace
                    SPIADI.
                  </p>
                  <btn type="default"
                       block
                       @click="$router.push('/establishments/list')">
                    Accéder à l'espace SPIADI
                  </btn>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     :href="require(`@/assets/documents/2023/OBSERVA4.zip`)"
                     target="_blank"
                     download="SPIADI2023 - OBSERVA4.zip">
                    Protocoles
                  </a>
                </div>
              </div>
              <div class="panel panel-cleanHandProx">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>CleanHand PROX</h3>
                    <p>
                      Améliorer l’hygiène des mains et le port de gants
                      stériles pour les manipulations proximales
                      et la pose d’aiguille sur CCI
                    </p>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-cleanHandProx btn-block"
                     role="button"
                     target="_blank"
                     download="SPIADI2023 - Rapport National CleanHand PROX - juin 2024.pdf"
                     :href="require(`@/assets/documents/2023/SPIADI2023 - Rapport National CleanHand PROX - juin 2024.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     :href="require(`@/assets/documents/2023/CLEANHANDPROX.zip`)"
                     target="_blank"
                     download="SPIADI2023 - CleanHandPROX.zip">
                    Protocoles
                  </a>
                </div>
              </div>

            </div>
          </div>
        </page-section>
      </tab>
      <tab title="Année 2022">
        <page-section title="Année 2022">
          <div class="row">
            <div class="col-xs-12 col-md-6 col-md-offset-3">
              <div class="panel panel-indicator-ok">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Rapport annuel d'activité</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <a class="btn btn-indicator-ok btn-block"
                     role="button"
                     target="_blank"
                     download="SPIADI2022 - Rapport annuel d'activité.pdf"
                     :href="require(`@/assets/documents/2022/SPIADI2022 - Rapport annuel d'activité.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-md-6">
              <div class="panel panel-reaInfADI">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Surveillance des infections</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-reaInfADI btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2022/SPIADI2022 - Rapport National provisoire - juillet 2023.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                  <hr>
                  <h4>Résultats nationaux</h4>
                  <p>
                    Les résultats nationaux ont été présentés lors de la journée
                    nationale SPIADI, le 18 octobre 2022.
                  </p>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/Mission Day/2022/nvdm.pdf`)"
                     download="SPIADI2022 - Premiers résultats de la surveillance nationale.pdf">
                    Diaporama de présentation des résultats
                  </a>
                  <hr>

                  <h4>Résultats locaux</h4>
                  <p>
                    Les responsables du programme peuvent accéder aux
                    résultats de leur.s établissement.s via leur espace
                    SPIADI.
                  </p>
                  <btn type="default"
                       block
                       @click="$router.push('/establishments/list')">
                    Accéder à l'espace SPIADI
                  </btn>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2022/SPIADI2022.zip`)"
                     download="SPIADI2022 - SURVEILLANCE.zip">
                    Protocoles
                  </a>
                </div>
              </div>
              <div class="panel panel-cleanHand4">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>CleanHand4</h3>
                    <p>
                      Étude de l’impact d’une stratégie de formation
                      sur l’amélioration de l’hygiène des mains
                      lors de la pose d’un Cathéter Veineux Périphérique court
                    </p>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-cleanHand4 btn-block"
                     role="button"
                     target="_blank"
                     download="SPIADI2022 - Rapport national CLEANHAND4 - juillet 2023.pdf"
                     :href="require(`@/assets/documents/2022/SPIADI2022 - Rapport national CLEANHAND4.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     :href="require(`@/assets/documents/2022/CLEANHAND4.zip`)"
                     target="_blank"
                     download="SPIADI2022 - CLEANHAND4.zip">
                    Protocoles
                  </a>
                </div>
              </div>
              <div class="panel panel-reaExplaur">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>RÉA expl AUR</h3>
                    <p>Étude des souches de <i>Staplylococcus aureus</i>
                      associé aux bactériémies liées à un cathéter
                      dans les services de Réanimation et unités de soins continus</p>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-reaExplaur btn-block"
                     role="button"
                     target="_blank"
                     disabled
                     download="SPIADI2022 - Rapport RÉA explAUR - juillet 2023.pdf">
                    Rapport (transmis à Santé Publique France)
                  </a>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     :href="require(`@/assets/documents/2022/REAEXPLAUR.zip`)"
                     target="_blank"
                     download="SPIADI2022 - RÉA expl AUR.zip">
                    Protocoles
                  </a>
                </div>
              </div>
            </div>

            <div class="col-xs-12 col-md-6">
              <div class="panel panel-observa4">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Observation des pratiques</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-observa4 btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2022/SPIADI2022 - Rapport OBSERVA4 provisoire - juillet 2023.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                  <hr>
                  <h4>Résultats nationaux</h4>
                  <p>
                    Les résultats nationaux ont été présentés lors de la journée
                    nationale SPIADI, le 18 octobre 2022.
                  </p>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/Mission Day/2022/observa4.pdf`)"
                     download="SPIADI2022 - Résultats OBSERVA4.pdf">
                    Diaporama de présentation des résultats
                  </a>
                  <hr>
                  <h4>Résultats locaux</h4>
                  <p class="text-justify">
                    Les responsables du programme peuvent accéder aux
                    résultats de leur.s établissement.s via leur espace
                    SPIADI.
                  </p>
                  <btn type="default"
                       block
                       @click="$router.push('/establishments/list')">
                    Accéder à l'espace SPIADI
                  </btn>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     :href="require(`@/assets/documents/2022/OBSERVA4.zip`)"
                     target="_blank"
                     download="SPIADI2022 - OBSERVA4.zip">
                    Protocoles
                  </a>
                </div>
              </div>

              <div class="panel panel-echoGuidage">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Échoguidage</h3>
                    <p>
Etude des pratiques pour la pose des cathéters centraux et des MIDlines avec
prolongateur intégré sous échoguidage
                    </p>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-echoGuidage btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2022/SPIADI2022 - Rapport national Échoguidage.pdf`)"
                     download="SPIADI2022 - Rapport national Échoguidage - juillet 2023.pdf">
                    Rapport (transmis à Santé Publique France)
                  </a>
                  <hr>
                  <h4>Résultats nationaux</h4>
                  <p>
                    Les résultats nationaux ont été présentés lors de la journée
                    nationale SPIADI, le 18 octobre 2022.
                  </p>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/Mission Day/2022/echo.pdf`)"
                     download="SPIADI2022 - Présentation de l'étude Échoguidage.pdf">
                    Diaporama de présentation des résultats
                  </a>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     :href="require(`@/assets/documents/2022/ECHOGUIDAGE.zip`)"
                     target="_blank"
                     download="SPIADI2022 - ÉCHOGUIDAGE.zip">
                    Protocoles
                  </a>
                </div>
              </div>
            </div>
          </div>
        </page-section>
      </tab>
      <tab title="Année 2021">
        <page-section title="Année 2021">
          <div class="row">
            <div class="col-xs-12 col-md-6 col-md-offset-3">
              <div class="panel panel-indicator-ok">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Rapport annuel d'activité</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <a class="btn btn-indicator-ok btn-block"
                     role="button"
                     target="_blank"
                     download="SPIADI2021 - Rapport annuel d'activité.pdf"
                     :href="require(`@/assets/documents/2021/SPIADI2021 - Rapport annuel d'activité.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-md-6">
              <div class="panel panel-reaInfADI">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Surveillance des infections</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-reaInfADI btn-block"
                     role="button"
                     target="_blank"
                     download="SPIADI2021 - Rapport National provisoire - juin 2022.pdf"
                     :href="require(`@/assets/documents/2021/SPIADI2021 - Rapport National provisoire - juin 2022.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                  <hr>
                  <h4>Résultats nationaux</h4>
                  <p>
                    Les résultats nationaux ont été présentés lors de la journée
                    nationale SPIADI, le 7 octobre 2021.
                  </p>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/Mission Day/2021/surv.pdf`)"
                     download="SPIADI2021 - Premiers résultats de la surveillance nationale.pdf">
                    Diaporama de présentation des résultats
                  </a>
                  <hr>

                  <h4>Résultats locaux</h4>
                  <p>
                    Les responsables du programme peuvent accéder aux
                    résultats de leur.s établissement.s via leur espace
                    SPIADI.
                  </p>
                  <btn type="default"
                       block
                       @click="$router.push('/establishments/list')">
                    Accéder à l'espace SPIADI
                  </btn>
                  <hr>

                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2021/SPIADI2021.zip`)"
                     download="SPIADI2021.zip">
                    Protocoles
                  </a>
                </div>
              </div>
              <div class="panel panel-reaExplaur">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>RÉA expl AUR</h3>
                    <p>Étude des souches de <i>Staplylococcus aureus</i>
                      associé aux bactériémies liées à un cathéter
                      dans les services de Réanimation et unités de soins continus</p>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-reaExplaur btn-block"
                     role="button"
                     target="_blank"
                     download="SPIADI2021 - Rapport RÉA explAUR.pdf"
                     :href="require(`@/assets/documents/2021/SPIADI2021 - Rapport RÉA explAUR.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2021/REAEXPLAUR.zip`)"
                     download="SPIADI2021 - RÉA expl AUR.zip">
                    Protocoles
                  </a>
                </div>
              </div>
            </div>

            <div class="col-xs-12 col-md-6">
              <div class="panel panel-observa4">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Observation des pratiques</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-observa4 btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2021/SPIADI2021 - Rapport OBSERVA4 provisoire - février 2022.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                  <hr>
                  <h4>Résultats nationaux</h4>
                  <p>
                    Les résultats nationaux ont été présentés lors de la journée
                    nationale SPIADI, le 7 octobre 2021.
                  </p>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/Mission Day/2021/observa4.pdf`)"
                     download="SPIADI2021 - Résultats de l'enquête OBSERVA4.pdf">
                    Diaporama de présentation des résultats
                  </a>
                  <hr>
                  <h4>Résultats locaux</h4>
                  <p class="text-justify">
                    Les responsables du programme peuvent accéder aux
                    résultats de leur.s établissement.s via leur espace
                    SPIADI.
                  </p>
                  <btn type="default"
                       block
                       @click="$router.push('/establishments/list')">
                    Accéder à l'espace SPIADI
                  </btn>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     :href="require(`@/assets/documents/2021/OBSERVA4.zip`)"
                     target="_blank"
                     download="SPIADI2021 - OBSERVA4.zip">
                    Protocoles
                  </a>
                </div>
              </div>
            </div>
          </div>
        </page-section>
      </tab>
      <tab title="Année 2020">
        <page-section title="Année 2020">
          <div class="row">
            <div class="col-xs-12 col-md-6 col-md-offset-3">
              <div class="panel panel-indicator-ok">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Rapport annuel d'activité</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <a class="btn btn-indicator-ok btn-block"
                     role="button"
                     target="_blank"
                     download="SPIADI2020 - Rapport annuel d'activité.pdf"
                     :href="require(`@/assets/documents/2020/SPIADI2020 - Rapport annuel d'activité.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-md-6">
              <div class="panel panel-reaInfADI">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Surveillance des infections</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-reaInfADI btn-block"
                     role="button"
                     target="_blank"
                     href="https://www.santepubliquefrance.fr/maladies-et-traumatismes/infections-associees-aux-soins-et-resistance-aux-antibiotiques/infections-associees-aux-soins/documents/rapport-synthese/surveillance-des-infections-associees-aux-dispositifs-invasifs.-mission-nationale-spiadi.-resultats-de-la-surveillance-menee-en-2020">
                    Télécharger
                  </a>
                  <hr>
                  <h4>Résultats nationaux</h4>
                  <p>
                    Les résultats nationaux ont été présentés lors de la journée
                    nationale SPIADI, le 7 octobre 2021.
                  </p>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/Mission Day/2020/nvdm.pdf`)"
                     download="SPIADI2020 - Premiers résultats de la surveillance nationale.pdf">
                    Bactériémies - Premiers résultats
                  </a>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/Mission Day/2020/pneumopathies.pdf`)"
                     download="SPIADI2020 - Surveillance des pneumopathies - Premiers résultats.pdf">
                    Pneumopathies - Premiers résultats
                  </a>
                  <hr>
                  <h4>Résultats locaux</h4>
                  <p>
                    Les responsables du programme peuvent accéder aux
                    résultats de leur.s établissement.s via leur espace
                    SPIADI.
                  </p>
                  <btn type="default"
                       block
                       @click="$router.push('/establishments/list')">
                    Accéder à l'espace SPIADI
                  </btn>
                  <hr>

                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2020/SPIADI2020.zip`)"
                     download="SPIADI2020.zip">
                    Protocoles
                  </a>
                </div>
              </div>
              <div class="panel panel-reaSink">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>RÉA Sink</h3>
                    <p>
                      Sensibilisation au risque épidémique associé à la
                      contamination de l'environnement des patients à partir
                      des bactéries colonisant les points d'eau dans les
                      services de Réanimation
                    </p>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>

                  <a class="btn btn-reaSink btn-block"
                     role="button"
                     target="_blank"
                     disabled
                     v-tooltip.unenterable="'En cours de rédaction...'"
                     download="SPIADI2020 - RÉA Sink - Rapport National Provisoire.pdf">
                    Rapport provisoire
                  </a>
                  <hr>

                  <h4>Résultats nationaux</h4>
                  <a class="btn btn-default btn-block"
                     role="button"
                     :href="require(`@/assets/documents/Mission Day/2020/rea sink.pdf`)"
                     target="_blank"
                     download="SPIADI2020 - Résultats de l'enquête RÉA Sink.pdf">
                    Diaporama de présentation des résultats
                  </a>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     :href="require(`@/assets/documents/2020/REASINK.zip`)"
                     target="_blank"
                     download="SPIADI2020 - RÉA Sink.zip">
                    Protocoles 2020
                  </a>
                </div>
              </div>
            </div>

            <div class="col-xs-12 col-md-6">
              <div class="panel panel-observa4">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Observation des pratiques</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-observa4 btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2020/SPIADI2020 - Rapport OBSERVA4 provisoire - mai 2021.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                  <hr>
                  <h4>Résultats nationaux</h4>
                  <p>
                    Les résultats nationaux ont été présentés lors de la journée
                    nationale SPIADI, le 7 octobre 2021.
                  </p>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/Mission Day/2020/observa4.pdf`)"
                     download="SPIADI2020 - Résultats de l'enquête OBSERVA4.pdf">
                    Diaporama de présentation des résultats
                  </a>
                  <hr>
                  <h4>Résultats locaux</h4>
                  <p class="text-justify">
                    Les responsables du programme peuvent accéder aux
                    résultats de leur.s établissement.s via leur espace
                    SPIADI.
                  </p>
                  <btn type="default"
                       block
                       @click="$router.push('/establishments/list')">
                    Accéder à l'espace SPIADI
                  </btn>
                  <hr>
                  <a class="btn btn-default btn-block"
                     role="button"
                     :href="require(`@/assets/documents/2020/OBSERVA4.zip`)"
                     download="SPIADI2020 - OBSERVA4.zip">
                    Protocoles
                  </a>
                </div>
              </div>
            </div>
          </div>
        </page-section>
      </tab>
      <tab title="Année 2019">
        <page-section title="Année 2019">
          <div class="row">
            <div class="col-xs-12 col-md-6 col-md-offset-3">
              <div class="panel panel-indicator-ok">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Rapport annuel d'activité</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <a class="btn btn-indicator-ok btn-block"
                     role="button"
                     target="_blank"
                     download="SPIADI2019 - Rapport annuel d'activité.pdf"
                     :href="require(`@/assets/documents/2019/SPIADI2019 - Rapport annuel d'activité.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                </div>
              </div>
              <div class="panel panel-reaInfADI">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Surveillance des infections</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <h4>Rapport national</h4>
                  <a class="btn btn-reaInfADI btn-block"
                     role="button"
                     target="_blank"
                     href="https://www.santepubliquefrance.fr/maladies-et-traumatismes/infections-associees-aux-soins-et-resistance-aux-antibiotiques/infections-associees-aux-soins/documents/rapport-synthese/surveillance-des-infections-associees-aux-dispositifs-invasifs.-mission-nationale-spiadi.-resultats-de-la-surveillance-menee-en-2019">
                    Télécharger
                  </a>
                  <hr>
                  <h4>Résultats nationaux</h4>
                  <p>
                    Les résultats nationaux ont été présentés lors de la journée
                    nationale SPIADI, le 15 octobre 2019.
                  </p>
                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/Mission Day/2019/nvdm.pdf`)"
                     download="SPIADI2019 - Résultats de la surveillance nationale.pdf">
                    Diaporama de présentation des résultats
                  </a>
                  <hr>
                  <h4>Résultats locaux</h4>
                  <p>
                    Les responsables du programme peuvent accéder aux
                    résultats de leur.s établissement.s via leur espace
                    SPIADI.
                  </p>
                  <btn type="default"
                       block
                       @click="$router.push('/establishments/list')">
                    Accéder à l'espace SPIADI
                  </btn>
                  <hr>

                  <a class="btn btn-default btn-block"
                     role="button"
                     target="_blank"
                     :href="require(`@/assets/documents/2019/SPIADI2019.zip`)"
                     download="SPIADI2019.zip">
                    Protocoles
                  </a>
                </div>
              </div>
            </div>
          </div>
        </page-section>
      </tab>
      <tab title="Année 2018">
        <page-section title="Année 2018">
          <div class="row">
            <div class="col-xs-12 col-md-6 col-md-offset-3">
              <div class="panel panel-indicator-ok">
                <div class="panel-heading">
                  <div class="panel-title">
                    <h3>Rapport annuel d'activité</h3>
                  </div>
                </div>
                <div class="panel-body">
                  <a class="btn btn-indicator-ok btn-block"
                     role="button"
                     target="_blank"
                     download="SPIADI2018 - Rapport annuel d'activité.pdf"
                     :href="require(`@/assets/documents/2018/SPIADI2018 - Rapport annuel d'activité.pdf`)">
                    Rapport (transmis à Santé Publique France)
                  </a>
                </div>
              </div>
            </div>
          </div>
        </page-section>
      </tab>
    </tabs>
  </div>
</template>

<script>
import downloads from '@/components/presentation/downloads'
import linkBlock from '@/components/linkBlock'
import pageSection from '@/components/pagesection'
import featureBlock from '@/components/featureBlock'
import horizontalFeatureBlock from '@/components/horizontalFeatureBlock'
import sc from '@/sc/presentation'
import { mapGetters } from 'vuex'

export default {
  name: 'results',

  data () {
    const tab = parseInt(this.$route.query.tab)
    return {
      tab: (isNaN(tab)) ? 0 : tab
    }
  },

  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn'
    }),

    texts: function () {
      return sc.texts
    },

    files: function () {
      return sc.files
    }
  },

  watch: {
    '$route.query.tab': function (v) {
      const t = parseInt(v)
      this.tab = (isNaN(t)) ? 0 : t
    }
  },

  components: {
    'downloads': downloads,
    'feature-block': featureBlock,
    'link-block': linkBlock,
    pageSection,
    'horizontal-feature-block': horizontalFeatureBlock
  },

  methods: {
    add () {
      this.$router.push('establishments')
    }
  }
}
</script>

<style scoped lang="less">
@import '~variables';

.panel {
  h3 {
    margin-top: 0rem;
    margin-bottom: 0rem;
    text-align: center;
  }

  h4 {
    margin-top: 1rem;
    text-align: center;
  }

  h5 {
    margin-top: 2rem;
  }

  .btn-block {
    max-width: 30rem;
    margin-left: auto;
    margin-right: auto;
  }

  p {
    text-align: center;
  }
}
</style>
